<template>
    <PageErrorFiveHundred :errors="errors">
        <ThButton
            class="button"
            @click="$emit('retry')"
        >
            {{ t('globals.try_again') }}
        </ThButton>

        {{ t('globals.or_alternatively') }}

        <ThButton
            :to="routeReset"
            class="button"
        >
            {{ t('globals.reset_filters') }}
        </ThButton>
    </PageErrorFiveHundred>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

import PageErrorFiveHundred from '@/components/PageErrorFiveHundred.vue'
import type { ErrorCollectionWithTraces } from '@/helpers/errors'
import ThButton from '@/components/ui/buttons/ThButton.vue'
import type { ButtonRouteRelative } from '@/components/ui/buttons/useThButton'

defineProps<{
    errors: ErrorCollectionWithTraces
    routeReset: ButtonRouteRelative
}>()

defineEmits<{
    (e: 'retry'): void
}>()

const { t } = useI18n()
</script>

<style scoped>
.button {
    margin: 20px 0;
}
</style>
